import React from 'react'
import Link from 'next/link'
import { Text } from '@components/rolex-ui/Text'
import { cn } from '@lib/cn'

type NavItem = {
  label: string
  href: string
}

const DesktopNav: React.FC<{ navItems: NavItem[]; language: string; routerPath: string }> = ({
  navItems,
  language,
  routerPath,
}) => (
  <nav className="rolex-desktop-nav w-full justify-end gap-6">
    {navItems.map((item, key) => {
      const cleanHref = item.href.replace(`/${language}`, '')
      const isActive = cleanHref === routerPath

      return (
        <Link href={item.href} key={key} type="link">
          <a>
            <Text
              variant="fixed16"
              className={cn(
                'text-white transition-colors duration-100 hover:text-rolexOceanGreen',
                isActive && 'text-rolexOceanGreen',
              )}
            >
              {item.label}
            </Text>
          </a>
        </Link>
      )
    })}
  </nav>
)

export default DesktopNav
